import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/downloads',
        name: 'downloads',
        component: () => import("./views/downloads.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User, CONST.AppRoles.Guest]
        }
    },
];

export default routes;
